var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart-donut"}},[_c('apexchart',{attrs:{"height":_vm.height || 350,"options":_vm.options,"series":_vm.series,"type":"donut","width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }